export const API_KEY = '9973533'; // PERSONAL API_KEY FROM PATREON
// const API_KEY = '1'; TEST API KEY
// const API_URL = `http://www.thecocktaildb.com/api/json/v1/${API_KEY}/search.php?s=margarita`;
export const API_URL = `https://www.thecocktaildb.com/api/json/v2/${API_KEY}/filter.php?c=`;
export const RES_PER_PAGE = 6;